import React, { useRef, useState } from 'react';
import { Box, Menu, MenuItem } from '@medely/web-components';
import { HelpIcon, useConfigurationContext } from '@medely/ui-kit';
import { ApplicationVideoModal } from '@mp/components/application/ApplicationVideoModal';
import { useApplicationHelpIconEvent } from '@mp/hooks/analytics/useApplicationHelpIconEvent';
import { useApplicationVideoGates } from '@mp';
import show from 'utils/Intercom/show';
import openInNewTab from 'utils/openInNewTab';

const ApplicationHeaderHelpIcon = (): React.ReactElement => {
  const { help } = useConfigurationContext();
  const { trackHelpIconOpened } = useApplicationHelpIconEvent();
  const { isAutoVideoPopupEnabled } = useApplicationVideoGates();
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleOpen = () => {
    trackHelpIconOpened({ platform: 'web' });
    setIsMenuOpen(true);
  };

  const handleClose = () => {
    setIsMenuOpen(false);
  };

  const handleChatWithSupport = () => {
    handleClose();
    show();
  };

  const handleApplicationVideo = () => {
    handleClose();
    setIsVideoOpen(true);
  };

  const handleHelpArticle = () => {
    handleClose();
    openInNewTab(help.url);
  };

  return (
    <>
      <Box ref={anchorRef} display="inline-flex" alignItems="center">
        <HelpIcon
          onPress={handleOpen}
          accessibilityLabel="Get help"
          testId="application-help-icon"
          color="text.secondary"
          iconSize="20px"
        />
      </Box>
      <Menu
        anchorEl={anchorRef.current}
        open={isMenuOpen}
        onClose={handleClose}
        data-testid="application-help-menu"
      >
        <MenuItem onClick={handleChatWithSupport}>Chat with support</MenuItem>
        <MenuItem onClick={handleHelpArticle}>Help article</MenuItem>
        {isAutoVideoPopupEnabled && (
          <MenuItem onClick={handleApplicationVideo}>Application video</MenuItem>
        )}
      </Menu>
      <ApplicationVideoModal
        isOpen={isVideoOpen}
        onClose={() => setIsVideoOpen(false)}
        source="help_icon"
      />
    </>
  );
};

export default ApplicationHeaderHelpIcon;
